import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import Layout from "../../components/common/pageLayout"
import './planApproval.css'
import { useEffect, useState } from "react"
import { v3_create_planApproval_Revision, v3_plan_approval_change_favourite_status, v3_planApproval, v3_planApproval_Status_Update } from "../../actions/v3/planApproval"
import { toast } from "react-toastify"
import Filter from '../../components/PlanApproval/ProjectPlanList/filter'
import List from '../../components/PlanApproval/ProjectPlanList/index'
import ExportColumnModal from "../../components/common/ExportColumnModal";
import { appendDateRangeToFileName, exportRowsToExcel } from '../../utils';

const planApprovalExportColumns = [
    { key: 'planName', label: 'Plan Name', value: (item) => item.PLAN_NAME },
    { key: 'planNumber', label: 'Plan Number', value: (item) => item.PLAN_NUMBER },
    { key: 'shipName', label: 'Ship Name', value: (item) => item.SHIP_NAME },
    { key: 'hullNumber', label: 'Hull Number', value: (item) => item.HULL_NUMBER },
    { key: 'channelName', label: 'Channel Name', value: (item) => item.CHANNEL_NAME },
    { key: 'categoryName', label: 'Category Name', value: (item) => item.CATEGORY_NAME },
    { key: 'planType', label: 'Plan Type', value: (item) => item.PLAN_TYPE },
    { key: 'planStatus', label: 'Plan Status', value: (item) => item.PLAN_STATUS },
    { key: 'status', label: 'Status', value: (item) => item.STATUS },
    { key: 'isFavourite', label: 'Is Favourite', value: (item) => item.IS_FAVOURITE ? 'Yes' : 'No' },
    { key: 'createdOn', label: 'Created On', value: (item) => item.CREATED_ON },
    { key: 'modifiedOn', label: 'Modified On', value: (item) => item.MODIFIED_ON },
    { key: 'totalComments', label: 'Total Comments', value: (item) => item.totalComments },
    { key: 'draftComments', label: 'Draft Comments', value: (item) => item.commentCountByStatus?.Draft || 0 },
    { key: 'openComments', label: 'Open Comments', value: (item) => item.commentCountByStatus?.Open || 0 },
    { key: 'acceptedComments', label: 'Accepted Comments', value: (item) => item.commentCountByStatus?.Accepted || 0 },
    { key: 'followUpComments', label: 'Follow Up Comments', value: (item) => item.commentCountByStatus?.['Follow Up'] || 0 },
    { key: 'cancelledComments', label: 'Cancelled Comments', value: (item) => item.commentCountByStatus?.Cancelled || 0 },
    { key: 'archivedComments', label: 'Archived Comments', value: (item) => item.commentCountByStatus?.Archived || 0 },
    { key: 'toBeConfirmedComments', label: 'To Be Confirmed Comments', value: (item) => item.commentCountByStatus?.['To Be Confirmed At Revision'] || 0 },
    { key: 'latestRevisionName', label: 'Latest Revision Name', value: (item) => item.revisions?.[0]?.REVISION_NAME || '' },
    { key: 'revisionRemarks', label: 'Revision Remarks', value: (item) => item.revisions?.[0]?.REMARKS || '' },
    { key: 'revisionCreatedOn', label: 'Revision Created On', value: (item) => item.revisions?.[0]?.CREATED_ON || '' },
    { key: 'revisionModifiedOn', label: 'Revision Modified On', value: (item) => item.revisions?.[0]?.MODIFIED_ON || '' },
    { key: 'assignees', label: 'Assignees', value: (item) => item.assignee?.map(a => a.FULL_NAME).join(', ') || '' },
];

const Project = () => {

    const location = useLocation();
    const { projectId, projectName, oldPage } = location.state;
    const [page, setPage] = useState(oldPage || 1)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [filterPayload, setFilterPayload] = useState({})


    useEffect(() => {
        v3_planApproval(page, limit, projectId, btoa(JSON.stringify(filterPayload))).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                toast.error(res.error || res.error.message)
            }
        })
    }, [page, limit, projectId, refresh, filterPayload])


    const onChangeFavouriteStatus = (payload) => {
        v3_plan_approval_change_favourite_status(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
            }
        })
    }

    const onAddRevision = (payload) => {
        v3_create_planApproval_Revision(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`revisionModal`));
                if (modal) modal.hide();
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })
    }

    const onUpdateStatus = (payload) => {
        v3_planApproval_Status_Update(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${payload.commentId}`));
                if (modal) modal.hide();
            }
        })
    }

    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
    }


    const exportExcel = async (selectedColumns = planApprovalExportColumns) => {
        try {
            let allData = [];
            let currentPage = 1;
            let totalPages = 1;

            // keep fetching until all pages are covered
            do {
                const res = await v3_planApproval(
                    currentPage,
                    limit, // you can also pass a big number like 1000 instead of looping
                    projectId,
                    btoa(JSON.stringify(filterPayload))
                );
                if (res.status) {
                    const result = res.result;
                    allData = [...allData, ...(result?.data || [])];

                    totalPages = result.totalPages


                    currentPage++;
                } else {
                    toast.error(res.error || res.error.message);
                    break;
                }
            } while (currentPage <= totalPages);

            if (allData.length === 0) {
                alert("No data to export");
                return;
            }

            exportRowsToExcel({
                rows: allData,
                columns: selectedColumns,
                sheetName: "Plans",
                fileName: `${appendDateRangeToFileName('plans', filterPayload)}.xlsx`,
            });

            toast.success("Excel exported successfully ✅");
        } catch (err) {
            console.error(err);
            toast.error("Failed to export Excel");
        }
    };


    return (
        <Layout title={`Plan Approval | ${projectName}`}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <Filter
                                planCountByStatus={data?.planCountByStatus}
                                onChangeFilter={onChangeFilter}
                            />
                            {data && <List
                                onAddRevision={onAddRevision}
                                onUpdateStatus={onUpdateStatus}
                                limit={limit}
                                records={data}
                                handlePageChange={(newPage) => setPage(newPage)}
                                onChangeFavouriteStatus={onChangeFavouriteStatus}
                            />}

                        </div>
                    </div>
                </div>
            </div>
            <ExportColumnModal
                modalId="plan-approval-export-columns-modal"
                title="Select Plan Approval Columns"
                columns={planApprovalExportColumns}
                onExport={exportExcel}
            />

        </Layout>

    )
}

export default Project
